import { Card, Container, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useAuth } from "../../context";

function Callback() {
  const navigate = useNavigate();
  const { authProvider } = useParams();
  const { login } = useAuth();

  const [ error, setError ] = useState<string>();

  useEffect(() => {
    const handleOAuth = async () => {
      const query = window.location.search;
      login(authProvider, query)
        .then(() => navigate("/"))
        .catch((error) => setError(error.message));
    };
    handleOAuth();
  }, [authProvider, login, navigate]);

  return (
    <Container placeContent="center" display="grid">
      <Card p="8" w="50ch" textAlign="center">
        { error ? (
          <>
            <Text as="h2" fontSize="large">Unable to sign in</Text>
            <Text fontSize="small">{ error }</Text>
          </>
        ) : (
          <Text as="h2" fontSize="large">Signing in...</Text>
        )}
      </Card>
    </Container>
  );
}

export default Callback;
